import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { Theme } from "styles/theme";

export const Title = styled.h3`
  font-size: ${props => props.theme.fontSize["6"]};
  color: ${props => props.theme.font.primary.default};
  text-align: center;
  line-height: ${props => props.theme.lineHeights[4]};
`;

export const Body = styled.p`
  font-size: ${props => props.theme.fontSize["5"]};
  color: ${props => props.theme.font.secondary.default};
  width: 100%;
  text-align: center;
  font-weight: ${props => props.theme.fontWeights["work-sans-2"]};
  line-height: ${props => props.theme.lineHeights[6]};
`;

// Helpers

export const buttonCss = (theme: Theme, isMobile: boolean) => css`
  width: ${isMobile ? 200 : 220}px;
  padding: 12px 14px;
  border-radius: 14px;
  justify-content: center;
  font-size: ${theme.fontSize[5]};
  font-weight: ${theme.fontWeights["work-sans-0"]};
  line-height: ${theme.lineHeights[2]};
  margin: auto;
`;
